import { useRoute } from '#imports'
import { computed, ref, shallowReactive } from 'vue'

import type { SearchConfiguration } from '@backmarket/http-api/src/api-specs-search-reco/search/searchConfiguration'
import { getInitialFiltersDict } from '@backmarket/nuxt-layer-recommendation/filtering/getInitialFiltersDict'

export function useSearchInputs(searchConfig: SearchConfiguration) {
  const route = useRoute()
  const query = computed(
    () =>
      (Array.isArray(route.query.q) ? route.query.q[0] : route.query.q) ?? '',
  )

  const filtersInput = shallowReactive(
    getInitialFiltersDict(searchConfig.facets),
  )
  const sortInput = ref(searchConfig.indexes.active.name)
  const pageInput = ref(
    Number.parseInt(route.query.p?.toString() || '1', 10) || 1,
  )
  const priceFilter = ref<[number, number]>()
  const isResetting = ref(false)

  function reset() {
    isResetting.value = true
    Object.assign(filtersInput, getInitialFiltersDict(searchConfig.facets))
    sortInput.value = searchConfig.indexes.active.name
    pageInput.value = 1
    priceFilter.value = undefined
    isResetting.value = false
  }

  return {
    query,
    filtersInput,
    sortInput,
    pageInput,
    priceFilter,
    reset,
    isResetting,
  }
}
